import { render } from "./AppTopbar.vue?vue&type=template&id=4d66e5c2&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=4d66e5c2&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d66e5c2"]])

export default __exports__